import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type LandingMobilePageStore } from 'pages/landingMobile/store/landingMobilePageStore'

export const LandingMobilePageContext = createContext<LandingMobilePageStore | null>(null)

export const useLandingMobilePageContext = () => {
  const context = useContext(LandingMobilePageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with LandingMobilePageContext')

  return context
}

type IProviderLandingMobilePageProps = {
  value: LandingMobilePageStore
  children: ReactNode
}

export const ProviderLandingMobilePage: FC<IProviderLandingMobilePageProps> = ({
  value,
  children,
}) => {
  return (
    <LandingMobilePageContext.Provider value={value}>{children}</LandingMobilePageContext.Provider>
  )
}
